import React from "react";

import "./FlashscanKPICard.scss";

type FlashscanKPICardProps = {
  label: React.ReactNode;
  value: React.ReactNode;
  subvalue?: React.ReactNode;
  variant?: "default" | "highlight";
};

export const FlashscanKPICard: React.FC<FlashscanKPICardProps> = ({
  label,
  value,
  subvalue,
  variant = "default",
}) => {
  const highlightClass = variant === "highlight" ? "flashscan-kpi-card--highlight" : "";

  return (
    <div className={`flashscan-kpi-card ${highlightClass}`}>
      <div className="flashscan-kpi-card-label">{label}</div>
      <div className="flashscan-kpi-card-value">{value}</div>
      {subvalue && <div className="flashscan-kpi-card-subvalue">{subvalue}</div>}
    </div>
  );
};

